export default "__VITE_PUBLIC_ASSET__6d3f6284__"